module.exports = __webpack_public_path__ + "static/media/icon-192x192.3d5ac160.png";